var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.0619C11.3807 20.0619 12.5 18.9426 12.5 17.5619H7.5C7.5 18.9426 8.61929 20.0619 10 20.0619Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.4597L9.00351 2.66095C6.7194 3.12225 5.00003 5.14268 5.00003 7.56189C5.00003 8.34667 4.83207 10.3085 4.42644 12.2396C4.22508 13.1983 3.95568 14.1964 3.59762 15.0619H16.4024C16.0443 14.1964 15.7749 13.1983 15.5736 12.2396C15.168 10.3084 15 8.34666 15 7.56189C15 5.14266 13.2806 3.12223 10.9965 2.66095L10 2.4597ZM17.7741 15.0619C18.0532 15.6211 18.3768 16.0631 18.75 16.3119H1.25C1.62316 16.0631 1.94681 15.6211 2.22587 15.0619C3.34903 12.8111 3.75003 8.66084 3.75003 7.56189C3.75003 4.53606 5.90025 2.01245 8.75605 1.43569C8.75205 1.39497 8.75 1.35367 8.75 1.31189C8.75 0.621534 9.30964 0.0618896 10 0.0618896C10.6904 0.0618896 11.25 0.621534 11.25 1.31189C11.25 1.35366 11.248 1.39496 11.2439 1.43568C14.0998 2.01242 16.25 4.53604 16.25 7.56189C16.25 8.66084 16.651 12.8111 17.7741 15.0619Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellTransparent);
export default __webpack_public_path__ + "static/media/bell-transparent.84c84157eaa786445167a326dcbf78a7.svg";
export { ForwardRef as ReactComponent };